import { render } from "./ArticleBrowser.vue?vue&type=template&id=3cd0b17e"
import script from "./ArticleBrowser.vue?vue&type=script&lang=js"
export * from "./ArticleBrowser.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/documentation.probabilityworks.cloud/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__